import type { JSX, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { useContext } from 'react';
import { styled, css } from 'styled-components';
import { TableSectionContext } from './TableSectionContext';

const sharedStyles = css`
  color: var(--wui-color-text);
  padding: var(--wui-space-02);
  text-align: left;
`;

const StyledTh = styled.th`
  ${sharedStyles}
  font-size: var(--wui-typography-body-4-size);
  font-weight: var(--wui-typography-weight-label-bold);
  line-height: var(--wui-typography-body-4-line-height);
`;

const StyledTd = styled.td`
  ${sharedStyles}
  font-size: var(--wui-typography-body-2-size);
  font-weight: var(--wui-typography-body-2-weight);
  line-height: var(--wui-typography-body-2-line-height);
`;

type CellAttrs = Omit<TdHTMLAttributes<HTMLTableCellElement>, 'ref'> &
  Omit<ThHTMLAttributes<HTMLTableCellElement>, 'ref'>;

export type TableCellProps = CellAttrs & {
  children?: ReactNode;
};

export const TableCell = ({ children, ...props }: TableCellProps): JSX.Element => {
  const section = useContext(TableSectionContext);

  if (section === 'head') {
    return <StyledTh {...props}>{children}</StyledTh>;
  }
  return <StyledTd {...props}>{children}</StyledTd>;
};
